import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'reactstrap';
import { ZipField } from 'site-modules/shared/components/appraisal/zip-field/zip-field';
import { VehicleDropdowns } from 'site-modules/shared/components/vehicle-dropdowns/vehicle-dropdowns';
import { ALLOWED_PUB_STATES } from 'site-modules/shared/constants/appraisal/appraisal';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VisitorModel } from 'client/data/models/visitor';
import { isUnknownZip } from 'site-modules/shared/utils/location';
import { isEmpty } from 'lodash-es';
import { validateZipCode, ZIP_CODE_INPUT } from 'site-modules/shared/utils/appraiser/appraiser-validation-helper';
import { VehicleEntities } from 'client/data/models/vehicle';
import { getQuery } from 'client/utils/location';

const ERROR_STYLE_ID = 'styleError';

export class AppraiseNowFormUI extends Component {
  static propTypes = {
    vehicle: VehicleEntities.StyleWithoutSubmodels,
    location: PropTypes.shape({}),
    onContinue: PropTypes.func,
    zipCode: PropTypes.string,
    setModelValue: PropTypes.func.isRequired,
    trackingValue: PropTypes.string,
    parentTrackingId: PropTypes.string,
  };

  static defaultProps = {
    vehicle: {},
    location: {},
    onContinue: null,
    zipCode: '',
    trackingValue: 'Continue',
    parentTrackingId: undefined,
  };

  state = {
    vehicle: null,
    errorMap: new Map(),
    zipCode: isUnknownZip(this.props.location) ? '' : this.props.zipCode,
    isZipCodeValid: true,
  };

  componentDidUpdate(prevProps) {
    const { zipCode } = this.props;
    const { zipCode: stateZipCode } = this.state;

    if (prevProps.zipCode !== zipCode && stateZipCode !== zipCode) {
      this.onPropsZipCodeChange(zipCode);
    }
  }

  onPropsZipCodeChange = zipCode => this.setState({ zipCode }, () => this.setValidatedZipStatus(true));

  setValidatedZipStatus = isZipCodeValid =>
    this.setState({ isZipCodeValid }, this.clearError(ZIP_CODE_INPUT, isZipCodeValid));
  /**
   * Handles zip code change.
   * @param {String} value
   */
  changeZipCode = value => {
    this.setState(() => ({
      zipCode: value,
    }));

    if (validateZipCode(value)) {
      this.updateLocationZip(value)
        .then(() => this.setValidatedZipStatus(true))
        .catch(() => this.setValidatedZipStatus(false));
    } else {
      this.setValidatedZipStatus(false);
    }
  };

  clearError =
    (errorId, isValid = true) =>
    () => {
      const { errorMap } = this.state;
      if (isValid) {
        errorMap.delete(errorId);
      }
      this.setState({ errorMap });
    };

  updateLocationZip = zipCode => this.props.setModelValue('location', VisitorModel, { zipCode });

  handleDropdownSelect = (make, model, year, style) => {
    this.setState({ vehicle: { make, model, year, style } }, this.clearError(ERROR_STYLE_ID));
  };

  validateData = () => {
    const { vehicle, isZipCodeValid } = this.state;
    const errorMap = new Map();
    if (isEmpty(vehicle)) {
      errorMap.set(ERROR_STYLE_ID, 'Please select a style');
    }
    if (!isZipCodeValid) {
      errorMap.set(ZIP_CODE_INPUT, 'Please enter your zip code');
      this.setValidatedZipStatus(false);
    }
    this.setState({ errorMap });
    return isEmpty(errorMap);
  };

  handleContinue = () => {
    const { vehicle } = this.state;
    const { onContinue, parentTrackingId } = this.props;
    if (this.validateData() && onContinue) {
      onContinue(vehicle, parentTrackingId);
    }
  };

  render() {
    const { vehicle, trackingValue, location } = this.props;
    const { zipCode, isZipCodeValid, errorMap } = this.state;
    const { styleIds } = getQuery(location);
    return (
      <Fragment>
        <Row>
          <Col xs={12} md={6}>
            <ZipField
              isZipCodeValid={isZipCodeValid}
              onZipCodeChange={this.changeZipCode}
              zipCode={zipCode}
              errorMap={errorMap}
              zipWrapperClassName="mb-1"
            />
          </Col>
          <Col xs={12} md={6}>
            <VehicleDropdowns
              tag="div"
              showAllSubmodels={!!vehicle}
              hasModel
              hasYear
              hasStyle
              vehicle={vehicle}
              hasOptionTruncate={false}
              inputClasses="form-control pe-2 mmy-select input-content"
              makeLabel="Make"
              modelLabel="Model"
              yearLabel="Year"
              styleLabel="Style"
              labelClassName="small mb-0_25"
              makeDropdownClassNames="d-none"
              modelDropdownClassNames="d-none"
              submodelDropdownClassNames="d-none"
              yearDropdownClassNames="d-none"
              styleDropdownClassNames="vehicle-dropdown-style-select mb-1_5 pe-0"
              buttonGroupClassNames="d-none"
              errorStyle={errorMap.get(ERROR_STYLE_ID)}
              onDropdownsSelect={this.handleDropdownSelect}
              pubStatesYears={ALLOWED_PUB_STATES}
              styleIds={styleIds}
              isStyledSelects
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <Button
              color="success"
              className="text-transform-none size-16 py-0_5"
              onClick={this.handleContinue}
              block
              data-tracking-id="submit_location_style"
              data-tracking-value={trackingValue}
            >
              Continue
            </Button>
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export const stateToPropsConfig = {
  location: bindToPath('location', VisitorModel),
  zipCode: bindToPath('location.zipCode', VisitorModel),
};

export const AppraiseNowForm = connectToModel(AppraiseNowFormUI, stateToPropsConfig);
